module.exports = __webpack_public_path__ + "img/2.152e8920.png";